
import { HttpClient } from '@angular/common/http';
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { formatDate } from '@angular/common';
import { FormatDataTableGlobal, FormatDataTableGlobalFive } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2';
import { ApiServiceProject } from '../../../../../apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

@Component({
  selector: 'project-step-3',
  templateUrl: './step3-project.component.html',
  styleUrls: ['./create-project.component.scss']
})
export class ProjectStep3Component implements  AfterViewInit, OnDestroy, OnInit  {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  listType
  listUser
  listAssigned
  idProject
  dtOptions: DataTables.Settings = {dom:'1.5'};
  step:number = 0
  title="Datos";
  crud = 'create';
  Step3form: FormGroup;
  private apiService: ApiServiceProject;
  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private errorService:ErrorService

  ) { 
   this.route.params.subscribe((params) => {
      this.idProject = params['id'];
    });
    this.route.url.subscribe((params)=>{
    this.crud=params[1].path;
    })

  }

 ngOnInit(): void {
    this.spinner.show()
    this.Step3form = this.fb.group({
    assigned:[''],
    user_id:[''],
    type_id:[''],
    start_date:[''],
    end_date:[''],
    });
    this.dtOptions = FormatDataTableGlobalFive();
    this.apiService = new ApiServiceProject(this.http);


    this.apiService.getService(`list-option-project-datos-step-three?id_project=${this.idProject}`).subscribe({
      next: (data) => {
        if (data) {
          this.listUser = data['listUser'];
          this.listType = data['listType'];
          this.listAsign();
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error ,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })
  }

  listAsign(){

    this.apiService.getService(`info-project-datos-step-three?id_project=${this.idProject}`).subscribe({
      next: (data) => {
        if (data) {
          this.listAssigned = data['listAssigned'];
          this.spinner.hide();
          this.rerender()
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error ,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })
  }


  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  formSubmit(){
    this.spinner.show()
    if ( !(Number(this.Step3form.value.assigned) > -1 ) || !(Number(this.Step3form.value.assigned) < 101 ) ) {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un porcentaje valido.',text: '',icon: 'error',heightAuto: false});
      return;
    }
    let startDate = moment(this.Step3form.value.start_date).format("DD-MM-YYYY");  

    let endDate = moment(this.Step3form.value.end_date).format("DD-MM-YYYY");

    let post = {
       projects_id:Number( this.idProject),
       user_id:Number(this.Step3form.value.user_id),
       type_id:Number(this.Step3form.value.type_id),
       start_date:startDate,
       end_date:endDate,
       assigned:Number( this.Step3form.value.assigned),
    }

    this.apiService.postService(`create-project-datos-step-three`,post).subscribe({
       next: (data) => {

         if (data.code == 1) {
        this.spinner.hide()
        Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
          } else {
            Swal.fire({title:data.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
            location.reload()
         })
           this.spinner.hide();
         }
      },
     error: (error) => {
      this.errorService.error(error);
     }})
  }
  stageDelete(id:any){
      Swal.fire({
                title: 'Eliminar',
                text: '¿Desea eliminar registro?',
                icon: 'warning',
                showCancelButton:true,
                confirmButtonText: 'Aceptar',
                cancelButtonText:"No, cancelar",
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed) {
                  this.spinner.show()
                  this.apiService.deleteService('delete-project-assigned-step-three?id=' + id).subscribe({
                    next: (rs: any) => {
                      if (rs) {
                        this.spinner.hide();
                        Swal.fire({title:'Exito!',text:'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                        
                      } else {
                          this.spinner.hide();
                          Swal.fire({title:rs.error ,text: '',icon: 'error',heightAuto: false}); } },
                    error: (error) => {
                      this.errorService.error(error);
                    },});
                }
                else if ( res.dismiss === Swal.DismissReason.cancel){
                  Swal.fire({title:'Cancelado' ,text: 'Operación cancelada.',icon: 'error',heightAuto: false});

                }
              });
    
    
  }
     stageActivate(id:any){
      Swal.fire({
                title: 'Activar',
                text: '¿Desea Activar registro?',
                icon: 'warning',
                showCancelButton:true,
                confirmButtonText: 'Aceptar',
                cancelButtonText:"No, cancelar",
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed) {
                  this.spinner.show()
                  this.apiService.putService('project-active-assigned-project?id=' + id).subscribe({
                    next: (rs: any) => {
                      if (rs) {
                        this.spinner.hide();
                        Swal.fire({title:rs.message,text: '',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                        
                      } else {
                          this.spinner.hide();
                          Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false}); } },
                    error: (error) => {
                      this.errorService.error(error);
                    },});
                }
                else if ( res.dismiss === Swal.DismissReason.cancel){
                  Swal.fire({title: 'Cancelado',text: 'Operación cancelada.',icon: 'error',heightAuto: false});
                }
              });
    
    
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

}
